import React, { useState, useEffect } from "react";
import { X, AlertTriangle } from "lucide-react";

const AUTO_CLOSE_SECONDS = 60;

const AnnouncementModal = () => {
  const [open, setOpen] = useState(false);
  const [remaining, setRemaining] = useState(AUTO_CLOSE_SECONDS);

  useEffect(() => {
    // Her site girişinde (sayfa yüklemesinde) göster.
    // Sayfalar arası gezinmede tekrar açılmaz (bileşen yeniden yüklenmez).
    const t = setTimeout(() => setOpen(true), 400);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!open) return;
    const interval = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          clearInterval(interval);
          setOpen(false);
          return 0;
        }
        return r - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [open]);

  if (!open) return null;

  const progress = (remaining / AUTO_CLOSE_SECONDS) * 100;

  return (
    <div
      className="fixed inset-0 z-[200] bg-[#050e1d]/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={() => setOpen(false)}
      role="dialog"
      aria-modal="true"
      aria-label="Önemli Duyuru"
    >
      <div
        className="announce-card relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Üst kırmızı şerit */}
        <div className="h-1.5 bg-red-600" />

        <button
          onClick={() => setOpen(false)}
          aria-label="Kapat"
          className="absolute top-4 right-4 w-10 h-10 rounded-full bg-slate-100 text-[#0d2b4f] flex items-center justify-center hover:bg-red-600 hover:text-white transition-colors duration-300"
        >
          <X size={20} />
        </button>

        <div className="px-6 sm:px-12 pt-10 pb-8 text-center">
          <div className="mx-auto w-14 h-14 rounded-full bg-red-50 text-red-600 flex items-center justify-center">
            <AlertTriangle size={26} />
          </div>

          <h2 className="mt-4 text-xl sm:text-2xl font-bold tracking-wide text-red-600 uppercase">
            Önemli Duyuru
          </h2>

          <div className="mt-2 flex items-center justify-center gap-3">
            <span className="h-px w-10 bg-red-200" />
            <span className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#5b6b7d]">
              Nikomedya Turizm
            </span>
            <span className="h-px w-10 bg-red-200" />
          </div>

          <div className="mt-6 max-h-[46vh] overflow-y-auto text-left sm:text-center">
            <p className="text-[#1a2433] text-sm sm:text-[15px] leading-relaxed">
              <span className="font-semibold underline underline-offset-2">
                05/08/2026
              </span>{" "}
              TARİHİNDE ŞİRKETİMİZ SABİT HATTINA GELEN BİR TELEFON ÜZERİNE BU
              AÇIKLAMAYI YAPMA GEREKLİLİĞİ DOĞMUŞTUR.
            </p>
            <p className="mt-4 text-[#1a2433] text-sm sm:text-[15px] leading-relaxed">
              ŞİRKETİMİZE AİT BİR KURULUŞ OLAN{" "}
              <span className="font-semibold">BENEFIT TRAVEL TURİZM</span>{" "}
              İSİMLİ VE <span className="font-semibold">11448 TÜRSAB</span>{" "}
              ACENTA NOLU İŞTİRAKİMİZ ADINA HİÇBİR ŞEKİLDE OTEL, MOTEL,
              PANSİYON, VİLLA, BUNGALOV VB. KONAKLAMAK AMACIYLA KİRALAMA
              HİZMETİMİZ OLMAMIŞTIR VE ŞU ANDA DA YOKTUR. SİZ DEĞERLİ
              MÜŞTERİLERİMİZİN BU UYARIYI DİKKATE ALMASINI VE ADIMIZI
              KULLANARAK BAHSİ GEÇEN HİZMETİ VERDİĞİNİ SÖYLEYEN VEYA VERECEĞİNİ
              TAAHHÜT EDEN KİŞİ VEYA KİŞİLERE İTİBAR ETMEMESİNİ ÖNEMLE RİCA
              EDERİZ.
            </p>
          </div>

          <button
            onClick={() => setOpen(false)}
            className="mt-7 inline-flex items-center gap-2 px-7 py-2.5 rounded-full bg-[#0d2b4f] text-white text-sm font-semibold hover:bg-[#123a66] transition-colors duration-300"
          >
            Anladım, Kapat
          </button>

          <p className="mt-4 text-xs text-[#5b6b7d]">
            Bu duyuru{" "}
            <span className="font-bold text-[#0d2b4f]">{remaining}</span> saniye
            içinde otomatik kapanacaktır.
          </p>
        </div>

        {/* Geri sayım çubuğu */}
        <div className="h-1 bg-slate-100">
          <div
            className="h-full bg-red-600 transition-all duration-1000 ease-linear"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
